import { NO_MEMBER } from './recordAddress';
const idsMatch = (a, b) =>
  a != null && b != null && a !== '' && b !== '' && String(a) === String(b);
const memberAnswersTo = (member, id) =>
  idsMatch(member?.familyMemberId, id) || idsMatch(member?.proBandId, id);

export const recordSubject = ({
  isNew,
  record,
  selectedMember,
  members
} = {}) => {
  if (isNew) return selectedMember || null;

  const address = record?.familyMemberId;
  if (!address || address === NO_MEMBER) return null;

  if (memberAnswersTo(selectedMember, address)) return selectedMember;

  const match = (members || []).find((m) => memberAnswersTo(m, address));
  return match || null;
};
